// @flow

import debounce from 'lodash.debounce';
import clone from 'lodash.clone';
import isObject from 'lodash.isobject';

import {ApiMethods} from './constants';
import {request} from './request';
import {createPromise} from './utils/create-promise';
import {getUrl} from './utils/get-url';

import type {CallInfo} from './typedef';


type RequestItem = {
    callInfo: CallInfo<*>,
    response: Promise<*>,
};

const MAX_REQUEST_SIZE = 30;

const BULK_REQUEST: 'BULK_REQUEST' = 'BULK_REQUEST';
const BULK_SUCCESS: 'BULK_SUCCESS' = 'BULK_SUCCESS';
const BULK_FAILURE: 'BULK_FAILURE' = 'BULK_FAILURE';
const BULK_API_ACTION = [BULK_REQUEST, BULK_SUCCESS, BULK_FAILURE];

class BulkApiService {
    _queue: Array<RequestItem> = [];
    dispatch = debounce(this._dispatch, 30);
    url: string = 'bulk';

    _dispatch(apiRoot: string) {
        const pendingQueue = clone(this._queue);

        request({
            types: BULK_API_ACTION,
            endpoint: this.url,
            method: ApiMethods.POST,
            TRANSPORT_REQUEST_BODY: {
                operations: pendingQueue.map(({callInfo}: RequestItem) => ({
                    url: `${getUrl(callInfo, apiRoot)}`,
                    method: callInfo.method || ApiMethods.GET,
                    headers: {},
                    params: callInfo.TRANSPORT_GET_PARAMS
                }))
            }
        }, apiRoot)
            .then(({responseData}) => {
                if (isObject(responseData) && Array.isArray(responseData.results)) {
                    responseData.results.forEach((resp, idx) => {
                         
                        // $FlowFixMe TODO: Cannot get responseData.results because property results is missing in String
                        const body = responseData.results[idx];
                        // $FlowFixMe TODO: Cannot call pendingQueue[idx].response.resolve because property resolve is missing in Promise
                        pendingQueue[idx].response.resolve(body);
                         
                    });
                }
            });

        this._queue = [];
    }

    add(req: CallInfo<*>, apiRoot: string) {
        const requestItem = {
            callInfo: req,
            response: createPromise()
        };

        this._queue.push(requestItem);

        if (this._queue.length === MAX_REQUEST_SIZE) {
            this.dispatch.flush();
        }

        this.dispatch(apiRoot);

        return requestItem.response;
    }
}

const bulkApiServiceSingleton: BulkApiService = new BulkApiService();
export default bulkApiServiceSingleton;

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
